import React, { useEffect, useState } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  Button,
  Row,
  Col,
} from "antd";

import { formItemLayout, tailFormItemLayout } from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
  onDeleteItem,
} from "../../utils/form_utilities";
import { authenticateAdmin } from "../../utils/authentications";
import RadioGroupFieldGroup from "../../commons/RadioGroupFieldGroup";
import {
  dealer_price_tag_options,
  other_payment_type_options,
} from "../../utils/Options";
import numberFormat from "../../utils/numberFormat";
import moment from "moment";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import { addKeysToArray } from "../../utils/utilities";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";

const { Content } = Layout;

const url = "/api/other-payments/";
const title = "Other Payments";

const initialValues = {
  _id: null,
  name: "",
  details: [],
};

const date_fields = [];
export default function OtherPaymentForm({ history }) {
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);

  const [state, setState] = useState(initialValues);
  const [item, setItem] = useState({});

  const records_column = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "other_payment_type",
    },
    {
      title: "Details",
      dataIndex: "details",
      render: (details) => (details || []).join(", "),
    },
    {
      title: "Included at POS",
      dataIndex: "is_included_at_pos",
      render: (value) => value && <span>&#10004;</span>,
      width: 50,
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      render: (status, record, index) => {
        if (record.deleted && record.deleted.date) {
          return (
            <span className="has-text-danger has-text-weight-bold">VOIDED</span>
          );
        }

        return <span>{status && status.approval_status}</span>;
      },
    },
    {
      title: "",
      key: "action",
      width: 10,
      render: (text, record) => (
        <span
          onClick={() =>
            edit({
              record,
              setErrors,
              setRecords,
              url,
              setState,
              date_fields,
            })
          }
        >
          <i className="fas fa-edit"></i>
        </span>
      ),
    },
  ];

  useEffect(() => {
    authenticateAdmin({
      role: auth.user?.role,
      history,
    });
    return () => {};
  }, []);

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onSearch={(value, e) => {
              e.preventDefault();
              onSearch({
                page: 1,
                search_keyword,
                url,
                setRecords,
                setTotalRecords,
                setCurrentPage,
                setErrors,
              });
            }}
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={() => {
              setRecords([]);
              setState({ ...initialValues, date: moment() });
            }}
          />
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              onSubmit({
                values: state,
                auth,
                url,
                setErrors,
                setState,
                date_fields,
              });
            }}
            initialValues={initialValues}
          >
            <TextFieldGroup
              label="Name"
              name="name"
              error={errors.name}
              formItemLayout={formItemLayout}
              value={state.name}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            />

            <SimpleSelectFieldGroup
              label="Other Payment Type"
              name="other_payment_type"
              value={state.other_payment_type}
              onChange={(value) => {
                onChange({
                  key: "other_payment_type",
                  value,
                  setState,
                });
              }}
              error={errors.other_payment_type}
              options={other_payment_type_options}
              formItemLayout={formItemLayout}
            />

            <CheckboxFieldGroup
              label="Included at POS"
              name="is_included_at_pos"
              error={errors.is_included_at_pos}
              formItemLayout={formItemLayout}
              checked={state.is_included_at_pos}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
            />

            <SelectTagFieldGroup
              label="Details"
              value={state.details}
              onChange={(value) => {
                onChange({
                  key: "details",
                  value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
              help="E.g. Card Number, Card Name"
            />

            <Divider orientation="left">w/ Selections</Divider>

            <SimpleSelectFieldGroup
              label="Detail"
              name="detail"
              value={item.detail}
              onChange={(value) => {
                onChange({
                  key: "detail",
                  value: value,
                  setState: setItem,
                });
              }}
              formItemLayout={formItemLayout}
              options={state.details || []}
            />

            <SelectTagFieldGroup
              label="Options"
              value={item.options || []}
              onChange={(value) => {
                onChange({
                  key: "options",
                  value,
                  setState: setItem,
                });
              }}
              formItemLayout={formItemLayout}
            />

            <Row>
              <Col offset={4} span={20}>
                <Button
                  onClick={() => {
                    setState((prevState) => {
                      return {
                        ...prevState,
                        item_details: [
                          ...(prevState.item_details || []),
                          { ...item },
                        ],
                      };
                    });
                    setItem({});
                  }}
                >
                  Add Selection
                </Button>
              </Col>
              <Col offset={4} span={20}>
                <Table
                  dataSource={addKeysToArray(state.item_details || [])}
                  columns={[
                    {
                      title: "Detail",
                      dataIndex: ["detail"],
                    },
                    {
                      title: "Options",
                      dataIndex: "options",
                      render: (options) => options.join(", "),
                    },
                    {
                      title: "",
                      key: "action",
                      width: 100,
                      render: (text, record, index) => (
                        <span
                          onClick={() =>
                            onDeleteItem({
                              field: "item_details",
                              index,
                              setState,
                            })
                          }
                        >
                          <i className="fas fa-trash-alt"></i>
                        </span>
                      ),
                    },
                  ]}
                  pagination={false}
                />
              </Col>
            </Row>

            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            {isEmpty(state.deleted) && (
              <Form.Item className="m-t-1" {...tailFormItemLayout}>
                <div className="field is-grouped">
                  <div className="control">
                    <button className="button is-small is-primary">Save</button>
                  </div>
                  {!isEmpty(state._id) ? (
                    <span
                      className="button is-danger is-outlined is-small"
                      onClick={() => {
                        onDelete({
                          id: state._id,
                          url,
                          user: auth.user,
                        });
                        setState({ ...initialValues, date: moment() });
                      }}
                    >
                      <span>Delete</span>
                      <span>
                        <i className="fas fa-times"></i>
                      </span>
                    </span>
                  ) : null}
                </div>
              </Form.Item>
            )}
          </Form>
        ) : (
          <Table
            dataSource={records}
            columns={records_column}
            rowKey={(record) => record._id}
            pagination={{
              current: current_page,
              defaultCurrent: current_page,
              onChange: (page) =>
                onSearch({
                  page,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                }),
              total: total_records,
              pageSize: 60,
            }}
          />
        )}
      </div>
    </Content>
  );
}
